<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template #activator="{on}">
      <v-btn
        flat
        @click="open(on)"
      >
        <v-icon left>
          mdi-percent
        </v-icon>
        Taxas
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>Editar configurações de taxas</span>
      </v-card-title>
      <v-card-text>
        <form-group>
          <v-flex
            xs12
            md12
            lg12
          >
            <v-layout
              align-start
              justify-start
            >
              <v-flex
                xs12
                md12
                lg6
              >
                <input-radio
                  v-model="payload.permitirContratoSimultaneo"
                  label="Permitir contratações simultâneas:"
                  :options="boolOptions"
                  row
                />
              </v-flex>
              <v-flex
                xs12
                md12
                lg6
              >
                <input-radio
                  v-model="payload.emprestimoValorVariavel"
                  label="Empréstimo com valor variável:"
                  :options="boolOptions"
                  row
                />
              </v-flex>
            </v-layout>
            <v-layout
              align-start
              justify-start
            >
              <v-flex
                xs12
                md12
                lg6
              >
                <input-radio
                  v-model="payload.permitirContratarEmprestimo"
                  label="Permitir empréstimo:"
                  :options="boolOptions"
                  row
                />
              </v-flex>
              <v-flex
                xs12
                md12
                lg6
              >
                <input-radio
                  v-model="payload.permitirContratarProrrogacao"
                  label="Permitir prorrogação:"
                  :options="boolOptions"
                  row
                />
              </v-flex>
            </v-layout>
            <v-layout
              align-start
              justify-start
            >
              <v-flex
                xs12
                md12
                lg6
              >
                <input-percentage
                  v-model="payload.taxaContratacaoEmprestimo"
                  :decimals="2"
                  label="Taxa do empréstimo"
                  outline
                />
              </v-flex>
              <v-flex
                xs12
                md12
                lg6
              >
                <input-money
                  v-model="payload.valorMaximoEmprestimoRapidoCliente"
                  label="Valor máximo do empréstimo rápido"
                  outline
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs12
                md12
                lg6
              >
                <input-percentage
                  v-model="payload.taxaContratacaoProrrogacao"
                  :decimals="2"
                  label="Taxa da prorrogação"
                  outline
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="loading"
          outlined
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          :loading="loading"
          color="success"
          class="ml-2"
          @click="edit()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import InputMoney from 'Support/components/inputs/InputMoney.vue';
import InputPercentage from 'Support/components/inputs/InputPercentage.vue';
import CustomerRequest from 'Domain/customers/CustomerRequest';
import notificationMixin from 'Support/mixins/notification-mixin';

export default {
  name: 'CustomerEditProrrogacaoModalColumn',
  components: {
    FormGroup,
    InputRadio,
    InputMoney,
    InputPercentage,
  },
  mixins: [notificationMixin],
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      requestClass: CustomerRequest,
      dialog: false,
      loading: false,
      payload: {
        emprestimoValorVariavel: '',
        permitirContratarEmprestimo: '',
        permitirContratoSimultaneo: '',
        taxaContratacaoEmprestimo: '',
        taxaContratacaoProrrogacao: '',
        valorMaximoEmprestimoRapidoCliente: '',
        permitirContratarProrrogacao: '',
      },
      boolOptions: [
        {
          label: 'Sim',
          value: true,
          color: 'success',
        },
        {
          label: 'Não',
          value: false,
          color: 'primary',
        },
      ],
    };
  },
  computed: {
    getData() {
      return this.row;
    },
    getId() {
      return this.value;
    },
  },
  methods: {
    open() {
      this.setRowData();
      this.dialog = true;
    },
    close() {
      this.setRowData();
      this.dialog = false;
    },
    setRowData() {
      const row = this.getData;
      if (row && typeof row === 'object') {
        const allowedProperties = [
          'emprestimoValorVariavel',
          'permitirContratarEmprestimo',
          'permitirContratoSimultaneo',
          'taxaContratacaoEmprestimo',
          'taxaContratacaoProrrogacao',
          'valorMaximoEmprestimoRapidoCliente',
          'permitirContratarProrrogacao',
        ];
        this.payload = {
          ...this.payload,
          ...Object.keys(row).reduce(
            (obj, key) => {
              const override = obj;
              if (allowedProperties.includes(key)) {
                override[key] = this.preparePayloadItem(key, row[key]);
              }
              return override;
            },
            {},
          ),
        };
      }
    },
    preparePayloadItem(key, value) {
      if (!['number', 'string'].includes(typeof value)) {
        return value;
      }

      if (this.isEmptyValue(value)) {
        return '';
      }

      const currency = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      return currency.format(Number(value)).replace('R$', '').trim();
    },
    async edit() {
      try {
        this.loading = true;
        await this.requestClass.configContratacoes(
          this.getId,
          this.preparePayload(),
        );
        this.$root.$emit(
          'refresh-crud-CustomersCrudList',
          true,
        );
        this.showSuccessToast({
          title: 'Sucesso',
          text: 'Sucesso ao atualizar configuração',
        });
        this.dialog = false;
      } catch (err) {
        this.showErrorToast({
          title: 'Falha ao atualizar configurações',
          text: this.getFaultErrorMessage(err),
        });
      } finally {
        this.loading = false;
      }
    },
    preparePayload() {
      const {
        taxaContratacaoEmprestimo,
        taxaContratacaoProrrogacao,
        valorMaximoEmprestimoRapidoCliente,
        ...rest
      } = this.payload;
      const override = {
        taxaContratacaoEmprestimo,
        taxaContratacaoProrrogacao,
        valorMaximoEmprestimoRapidoCliente,
      };
      return {
        ...rest,
        ...Object.keys(override)
          .reduce(
            (obj, key) => {
              const overObj = obj;
              const item = override[key];
              overObj[key] = !this.isEmptyValue(item)
                ? Number(String(item).split('.').join('').split(',')
                  .join('.')) : null;
              return overObj;
            },
            {},
          ),
      };
    },
    isEmptyValue(item) {
      return ['', null, undefined].includes(item);
    },
    getFaultErrorMessage(err) {
      if (!err) {
        return 'Houve erro na atualização, reveja os dados ';
      }

      if ('response' in err) {
        return err.response.data.message || err.response.data;
      }

      return err.message;
    },
  },
};
</script>
